/************************************CMS***********************************************/
import axios from "axios";
import http from "./request";
var downloadsetTimer = true;
// 获取token值  此处为固定账号登录
export const login = data => http.post("/cms/login", data);
// 获取页面模板样式   固定web_id: 1
export const getModulStyle = data => http.post("/cms/web/channel_list", data);
// 获取网站所拥有的模板 固定web_id: 1
export const getWebModels = data => http.post("/cms/web", Data(data));

//读取网页底部信息
export const getFooterInfo = data => http.post("/cms/web/service/show", data);

// 获取模块信息
export const getModuleInfo = (data, query) =>
  http.post("/cms/module", Data(data), null, {
    params: query
  });
// 获取某类别下资源

//获取分类id封面
export const getCategoryNode = data =>
  http.post("/source/category/getNodesInfo", data);

/***********************************Source*************************************************/
export const getResource = (data, type, page) => {
  var type = type ? type : 1;
  var page = page ? page : 1;
  return http.post(
    "/source/cms/search/?search_type=" + type + "&page=" + page,
    Data(data)
  );
};

// 资源库搜索需要登录
export const getResourceToken = (data, option, page) => {
  var page = page ? page : 1;

  return http.post("/source/search/asset?page=" + page, data, null, option);
};

// /api/purpose/getPurposeNodes   用途节点查询
export const getPurposeNodes = (data, option) =>
  http.post("/source/purpose/getPurposeNodes", data, option);
//POST/api/noValidation/getInfo  获取页面title

export const getdoctitle = data =>
  http.post("/source/noValidation/getInfo", data);
//获取分类子节点
export const getSpecialNode = data =>
  http.get("/source/category/getNodes", null, {
    params: data
  });
//获取组内资源
export const getGroup = data =>
  http.get("/source/cms/groupInfoCms", null, {
    params: data
  });
// 获取收藏夹列表
export const getFavoriteList = data =>
  http.get("/source/favorite/folderList", null, {
    params: data
  });
//添加收藏夹列表内资源
export const getFavoriteItem = data =>
  http.get("/source/favorite/ItemList", null, {
    params: data
  });
// 更新收藏夹
export const updateFavorite = data =>
  http.patch("/source/favorite/folderUpdate", data);
// 添加收藏夹
export const addFavorite = data => http.post("/source/favorite/add", data);
// 收藏夹删除
export const deleteFavorite = data =>
  http.delete("/source/favorite/folderDelete", null, {
    params: data
  });
//删除收藏夹内容
export const deleteFavoriteContent = data =>
  http.delete("/source/favorite/itemDelete", null, {
    params: data
  });
//移动收藏夹内容
export const MoveFavorite = data =>
  http.post("/source/favorite/itemMove", data);
// 个人中心获取下载记录
export const getDowLog = data =>
  http.get("/source/record/userDownload", null, {
    params: data
  });
// 收藏夹添加资源
export const addFavoriteAsset = data =>
  http.post("/source/favorite/addResource", data);
// 单一下载

export const onlyDownload = data => {
  if (downloadsetTimer) {
    downloadsetTimer = false;
    setTimeout(function() {
      downloadsetTimer = true;
    }, 1500);
    return http.get("/source/download/single", null, {
      params: data
    });
  }
};
//打包下载
export const allDownload = data => {
  if (downloadsetTimer) {
    downloadsetTimer = false;
    setTimeout(function() {
      downloadsetTimer = true;
    }, 1500);
    return http.get("/source/download/pack", null, {
      params: data
    });
  }
};
//供稿人作品上传
export const contributorSend = (data, option) =>
  http.post("/source/upload/photographer", data, null, option);
//获取客户信息
export const getcontributor = (data, option) =>
  http.post("/source/noValidation/getInfo", data, null, option);

/****************************************api************************************************/

//根据域名获取webid
export const getwebid = data => http.post("/cms/getCustom/byUrl", data);

// 地址获取站点与账号绑定信息
export const getSiteLogin = data =>
  http.post("/cms/getSiteLoginType/byUrl", data);

// 用户登录-通过客户端IP及账号
export const loginThrougUser = data =>
  http.post("/api/authorizationByClient", data);

// /api/category/resource/all  展示分类管理  获取整个分类树 （资源分类？）
export const newtitle = data =>
  http.get("/source/category/resource/all", null, data);

// category/list  资源库分类管理  获取资源库分类树 （展示分类？）
export const newtitle1 = data => http.get("source/category/list", null, data);

// http://60.205.57.44:3000/mock/11/api/user/ReSetPasswordByEmail

export const resetPassword = data =>
  http.post("./api/user/ReSetPasswordByEmail", data);
// ttp://60.205.57.44:3000/mock/11/api/user/ReSetPasswordBySms
export const resetPasswordbymobile = data =>
  http.post("./api/user/ReSetPasswordBySms", data);

// 用户登录验证
export const userLogin = data => http.post("/api/authorizations", data);
//登录增加积分
export const scoreLogin = data => http.post("/cms/profile/scoreLogin", data);
// 获取用户登录信息
export const getUserInfo = option => http.get("/api/user", null, option);
// 更改用户信息
export const updateUserInfo = data => http.patch("/api/user", data);
// 更改密码
export const updatePassword = data =>
  http.post("/api/user/reset_password", data);
// 退出登录
export const signOut = data => http.get("/api/user/logout");
// 用户注册
export const registerUser = data => http.post("/api/user/register", data);
//供稿人申请
/**
 * 供稿人申请
 * @param {*} data --供稿人申请
 * @param {*} option
 */
export const contributorUser = (data, option) =>
  http.post("/api/user/photographer_reg", data, null, option);
// 获取图形验证码
export const getImgCode = () => http.get("/api/captchaInfo/1");
// http://60.205.57.44:3000/mock/11/api/oauth
export const oauth = data => http.post("api/oauth", data);

// 发送验证码到邮箱
export const sendCode = data =>
  http.post(`/api/sendMailCode/${data.type}/${data.uuid}`, data);

//  发送短信验证码 http://60.205.57.44:3000/mock/11/api/sendSmsCode/{type}/{uuid}

export const sendSmsCode = data =>
  http.post(`/api/sendSmsCode/${data.type}/${data.uuid}`, data);

/*********************************************************************************************/
// 请求blob
export const getImageBlob = url =>
  http.get(url, undefined, {
    responseType: "blob",
    withCredentials: false
  });

/**
 * 判断用户是否有效
 * @param {object} data  --判断用户是否有效
 */
export const checkAccount = data => http.post("/api/user/checkAccount", data);

function Data(data) {
  var val = "";
  for (let key in data) {
    val += key + "=" + data[key] + "&";
  }
  return val;
}
// 查看某个任务
export const taskDetail = data => http.post("/cms/tasks/show", data);
//下载附件
// export const downloadAttachment = data => http.get('/cms/tasks/download_attachment',null,data)
export const downloadAttachment = data => {
  if (downloadsetTimer) {
    downloadsetTimer = false;
    return http.post("/cms/profile/download", data);
  }
  setTimeout(function() {
    downloadsetTimer = true;
  }, 1500);
};
//下载附件,无时间限制
export const downloadAttachmentMany = data => {
  return http.post("/cms/profile/download", data);
};
// 评审作品的更新
export const worksUpdate = data => http.patch("/source/group/update", data);
// 提交评审作品
export const submitWorks = data => http.post("/cms/tasks/complete", data);

// 组资源 搜索
export const searchAsset = (data, option) =>
  http.post("/source/cms/search", data, null, option);

// 获取分类下节点信息
export const categoryNode = data =>
  http.get("/source/category/getNodes", null, data);

// 获取分类节点详细信息
export const categoryNodeInfo = data =>
  http.post("/source/category/getNodesInfo", data);

// /api/authorizationWithCode
export const authorizationWithCode = data =>
  http.post("/api/authorizationWithCode", data);

// /api/authorizationGetCode
export const authorizationGetCode = data =>
  http.post("/api/authorizationGetCode", data);
//根据域名获取id
// export const getWebId = (status) => http.post('/cms/getCustom/byUrl', status)
//获取用户信息
export const getWebUser = data =>
  http.post("/source/noValidation/getInfo", data);

// /api/columnSwitch/query  获取租户字段配置Required
export const getColumnSwitch = data =>
  http.post("/source/columnSwitch/queryRequired", data);

//获取地域（组织机构树）所有节点信息
export const territoryList = data => {
  return http.get(`/api/org/show_node${data}`);
};

export const getassetsInfoCms = data => {
  return http.get(`/source/cms/assetsInfoCms`, null, {
    params: data
  });
};

export const getVCGID = data => {
  return http.post(`/source/cms/vidConvert`, data);
};



// WEBPACK FOOTER //
// ./src/services/api.js